import { render, staticRenderFns } from "./PdfParametersNeuroscience.vue?vue&type=template&id=1f09d74e&"
import script from "./PdfParametersNeuroscience.vue?vue&type=script&lang=ts&"
export * from "./PdfParametersNeuroscience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports